import asyncActionTypes from '../actions/types';

const initialState = {
  pendingOpen: false,
};

const pendingOpenModalLogin = (state = initialState, action) => {
  if (action.type === asyncActionTypes.PENDING_OPEN_MODAL_LOGIN) {
    return {
      ...state,
      pendingOpen: action.pendingOpen,
    };
  } else {
    return state;
  }
};

export default pendingOpenModalLogin;

